"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "initCommand", {
    enumerable: true,
    get: function() {
        return initCommand;
    }
});
const _commander = require("commander");
const _action = require("./action.js");
const initCommand = new _commander.Command("init");
initCommand.description("Install lage in a workspace and create a config file").action(_action.initAction);
